import {faCircleExclamation} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Text, View} from 'native-base';

export interface PRWarningBannerProps {
  label: string;
  testID: string;
}

const PRWarningBanner: React.FC<PRWarningBannerProps> = ({label, testID}) => {
  return (
    <View
      width="100%"
      py="14px"
      px={4}
      backgroundColor="#f4dbda" //TODO - place in the theme if we're going to support this color
      flexDirection="row"
      alignItems="center"
      testID={`${testID}-warning-banner`}
    >
      <FontAwesomeIcon
        icon={faCircleExclamation}
        color="#D32F2F" //TODO - place in the theme if we're going to support this color
        style={{fontSize: 22, marginRight: '12px'}}
      />
      <Text
        color={`#000000CC`} //TODO - place in the theme if we're going to support alpha
        fontSize="14px"
        fontWeight={400}
        lineHeight="20px"
      >
        {label}
      </Text>
    </View>
  );
};

export default PRWarningBanner;
